import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataService } from '../utils/data.service';
import {Http} from '@angular/http';
import {utils} from '../utils/utils';

@Injectable()
export class LoginGuard implements CanActivate {
  public _utils:utils;
	constructor(private _router:Router, public dataService: DataService,private _http:Http){
    this._utils = new utils();
  }
  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean>|boolean {
        /*return this._http.get(this._utils.url+"seguridad/checkSession").map((auth:any) => {
            if (auth._body == "true") {
                return true;
            }
            this._router.navigate(['/login']);
            return false;
        });*/
        if(sessionStorage.getItem("acslo") === null)
        {
          this._router.navigate(['/login']);
          return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.guard.ts